import styled from 'styled-components'
import theme from 'styles/theme'

export const CarouselCardWrapper = styled.div`
  padding: 0;
  transition: transform 0.8s ease-in-out;
  transition-timing-function: cubic-bezier(0.54, 0, 0.15, 1);
  transform: translate3d(0, 0, 0);
  height: 100%;
  padding-left: ${(props) => (props.isLast ? theme.space[3] : 0)};
  padding-right: ${(props) => (props.isLast ? 0 : theme.space[3])};

  ${theme.mediaQueries.large} {
    padding: 0;
  }
`

export default {
  CarouselCardWrapper,
}
